// @flow
export const filterId: 'account' = 'account';
